angular.module('contrast.chart.util', []).constant('ChartConstants', {
  colors: {
    GREEN: '#94b758',
    BLUE: '#578ebe',
    ORANGE: '#f3c536',
    PINK: '#fa7b58',
    RED: '#c01920',
    GRAY: '#767676'
  },
  barChartOptions: {
    series: {
      bars: {
        show: true,
        fill: 1,
        barWidth: 0.9,
        align: 'center',
        horizontal: false,
        order: 1
      }
    },
    highlightColor: 'rgba(255,255,255,0.4)',
    xaxis: {
      show: false
    },
    yaxis: {
      min: 0,
      tickFormatter: function suffixFormatter(val) {
        return val.toFixed(0) + ' '
      },
      minTickSize: 1
    },
    grid: {
      hoverable: true,
      borderWidth: 1,
      borderColor: '#eeeeee'
    },
    legend: {
      show: true,
      container: null,
      noColumns: 1
    },
    colors: ['#94b758', '#578ebe', '#f3c536', '#fa7b58', '#c01920'],
    tooltip: true,
    tooltipOpts: {
      shifts: {
        x: -10,
        y: -70
      },
      content: function (label, xval, yval) {
        return (
          "<span class='size-h4'><strong>%s</strong><br/>" +
          yval +
          ' vuln(s)</span>'
        )
      },
      defaultTheme: true
    }
  },

  //TODO Extract to service
  showModal: function (scope, modal) {
    return function () {
      modal.open({
        templateUrl: 'views/charts/modal_chart.html',
        controller: 'ChartCtrl',
        resolve: {
          chartParameters: function () {
            return scope.chartParameters
          }
        },
        size: 'lg'
      })
    }
  }
})
